import {
    draft,
    waiting_for_prompt_and_teacher,
    waiting_for_data,
    gathering_data,
    ready_for_distillation,
    distillation_in_progress,
    evaluation_in_progress,
    ready_to_deploy,
    deploy_in_progress,
    deployed,
    undeploy_in_progress,
} from '@/shared/constants/taskStatuses';
import { getTaskDraft } from '@/features/tasks/utils/taskDrafts';

export const STATUS_FILTER_OPTIONS = [
    draft,
    ready_to_deploy,
    deployed,
    distillation_in_progress,
    evaluation_in_progress,
    ready_for_distillation,
    waiting_for_prompt_and_teacher,
    waiting_for_data,
    gathering_data,
    deploy_in_progress,
    undeploy_in_progress,
];

/**
 * True when `usecase` matches the Filter By Status selection.
 *
 * Draft and Deployed follow what the card displays rather than `status`
 * alone: drafts are a local wizard overlay, and deployment is tracked by
 * `is_deployed` while `status` can remain e.g. "Ready to Deploy".
 */
export const matchesStatusFilter = (usecase, filter) => {
    if (!filter || filter === 'All') return true;
    const selected = Array.isArray(filter) ? filter : [filter];
    const isDraft = !!getTaskDraft(usecase);
    return selected.some((status) => {
        if (status === draft) return isDraft;
        if (isDraft) return false;
        if (status === deployed) {
            return !!usecase.is_deployed || usecase.status === deployed;
        }
        return usecase.status === status;
    });
};

export const formatStatusFilterLabel = (status, count = 0) => `${status} (${count})`;

/**
 * Count homepage tasks (sub_groups) per Filter By Status option.
 * A composed task increments every status that any of its usecases match,
 * matching how the filter keeps the whole task when one objective matches.
 */
export const countTasksByStatus = (apps) => {
    const counts = Object.fromEntries(STATUS_FILTER_OPTIONS.map((status) => [status, 0]));
    for (const app of apps || []) {
        for (const subGroup of app.sub_groups || []) {
            const usecases = subGroup.usecases || [];
            for (const status of STATUS_FILTER_OPTIONS) {
                if (usecases.some((usecase) => matchesStatusFilter(usecase, [status]))) {
                    counts[status] += 1;
                }
            }
        }
    }
    return counts;
};
